import { render } from "./Reminders.vue?vue&type=template&id=0b70eea6"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"

import "./Reminders.vue?vue&type=style&index=0&id=0b70eea6&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\doc\\MedRemind Project\\medremind-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__